"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ECheckPhoneStatus = void 0;
let ECheckPhoneStatus = exports.ECheckPhoneStatus = /*#__PURE__*/function (ECheckPhoneStatus) {
  ECheckPhoneStatus["Initial"] = "initial";
  ECheckPhoneStatus["Loading"] = "loading";
  ECheckPhoneStatus["Succeed"] = "succeed";
  ECheckPhoneStatus["Failed"] = "failed";
  return ECheckPhoneStatus;
}({});